import { useContext } from 'react';

import { Form } from 'react-bootstrap';

import { UserContext } from '../../context/UserContext';

const SuporteSistemas = props => {
  const { isConsulta } = useContext(UserContext);
  let subcategorias = props.getCategorias?.find(categoria => categoria.id === 15)?.subcategoria;

  const isConsultaNoSubcategories = [
    'Sistemas de Saúde',
  ];

  if (isConsulta) {
    subcategorias = subcategorias?.filter(item => !isConsultaNoSubcategories.includes(item.nome));
  }
  
  return (
    <>
      <Form.Group controlId="formSubCategoria" className="mt-4">
        <Form.Label>*Subcategoria:</Form.Label>
        <Form.Select
          className="border border-secondary"
          required
          name="formSubCategoria"
          onChange={e => props.handleSubcategoria(e)}
        >
          <option value="">Selecione a Subcategoria</option>
          {subcategorias.map(item => (
            <option key={item.nome} value={item.nome}>{item.nome}</option>
          ))}
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default SuporteSistemas;
// TODO suporte sistemas